module.exports = __webpack_public_path__ + "img/FPG-1.b0c46c12.jpg";